export const generatePrizeGroup = (countNumbersMatched: number): number => {
  switch (countNumbersMatched) {
    case 3:
      return 6;
    case 3.5:
      return 5;
    case 4:
      return 4;
    case 4.5:
      return 3;
    case 5:
      return 2;
    case 5.5:
      return 1;
    case 6:
      return 0;
  }
  return 0;
};
